"use strict";
export class GroupChangeController {
  hostConnected() {
  }
  constructor(host, authConfig) {
    this.host = host;
    this.authConfig = authConfig;
    this.host.addController(this);
  }
  updateGroupAndReload(url) {
    fetch(url, {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-TOKEN": this.authConfig.formAuthenticityToken
      }
    }).then((response) => {
      if (response.status === 200) {
        window.location.reload();
      } else {
        throw new Error("Something went wrong on the server.");
      }
    }).catch((error) => {
      console.error("Fetch error:", error);
    });
  }
}
